<div class="text-filter-content">
  <mat-form-field appearance="outline">
    <mat-label i18n="@@core.filter.value">Value</mat-label>
    <input matInput type="text" [formControl]="textControl" [aria-label]="label"/>
  </mat-form-field>
</div>
